module.exports = __webpack_public_path__ + "static/media/gearbox.dd690db9.svg";